function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "mediaviewer-expand",
  transform: "translate(-5.000000, 0.000000)",
  fill: "#979797",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(4.695145, 0.369184)"
}, React.createElement("polygon", {
  id: "Path",
  transform: "translate(6.304855, 13.513564) rotate(-270.000000) translate(-6.304855, -13.513564) ",
  points: "6.30485538 9.26163227 19 19.0271281 19.6097108 18.2345041 6.30485538 8 -7 18.2345041 -6.39028924 19.0271281"
}), React.createElement("polygon", {
  id: "Path-Copy",
  transform: "translate(13.304855, 13.513564) rotate(-270.000000) translate(-13.304855, -13.513564) ",
  points: "26 19.0271281 26.6097108 18.2345041 13.3048554 8 0 18.2345041 0.609710761 19.0271281 13.3048554 9.26163227"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "19px",
    height: "28px",
    viewBox: "0 0 19 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/mediaviewer-expand.58f0d506.svg";
export { SvgComponent as ReactComponent };